@if (isHeaderTextShown) {
  <div class="container alert alert-info">
    <h6 class="text-center mb-0" [innerHTML]="headerText">&nbsp;</h6>
  </div>
}

@if (isSubheaderTextShown) {
  <div class="container alert alert-info">
    <h6 class="text-center mb-0" [innerHTML]="subheaderText">&nbsp;</h6>
  </div>
}

@if (isPromptTextShown) {
  <div class="container alert alert-info">
    <h6 class="text-center mb-0" [innerHTML]="promptText">&nbsp;</h6>
  </div>
}

<div class="container wp-section">

    <form (ngSubmit)="onSubmitForEv(form.value)" [formGroup]="form">

        @if (isEvFieldsShown) {
          @for (formField of formFields; track formField) {
              <div class="mb-2">
                <app-form-field [formField]="formField" [form]="form"></app-form-field>
              </div>
          }
        }

        @if (isConsentPromptShown) {
        <div class="row alert alert-info">
           <h5 class="text-center" [innerHTML]="consentPrompt">&nbsp;</h5>
        </div>
        }

        @if(!isCloseButtonShown) {
          <div class="row justify-content-center">
              <div class="col-auto text-center text-nowrap">
                  <button type="submit" icon="fa fa-check" class="wp-btn wp-btn-submit" [disabled]="!form.valid">{{btnSubmit}}</button>
                  <button type="button" icon="fa fa-close" class="wp-btn wp-btn-cancel" (click)="onClose()" label="Cancel">{{btnCancel}}</button>
              </div>
          </div>
        }

        @if (isSuccessMessageShown) {
            <!-- <div class="alert alert-success" role="alert">{{successMessage}}</div> -->
            <div class="alert alert-success" role="alert" [innerHTML]="successMessage"></div>
        }
        @if (isErrorMessageShown) {
            <!-- <div class="alert alert-danger" role="alert">{{errorMessage}}</div> -->
            <div class="alert alert-danger" role="alert" [innerHTML]="errorMessage"></div>
        }

        @if(isCloseButtonShown) {
          <div class="row justify-content-center">
              <div class="col-auto text-center">
                  <button type="button" icon="fa fa-close" class="wp-btn wp-btn-cancel" (click)="onClose()" label="Close">Close</button>
              </div>
          </div>
        }


    </form>

</div>  

@if (isMoreInfoShown) {
  <div class="container alert wp-section">
    <h6 class="text-center mb-0" [innerHTML]="moreInfo"></h6>
  </div>
}

@if (isFooterTextShown) {
  <div class="container alert wp-section">
    <h6 class="text-center" [innerHTML]="footerText"></h6>
  </div>
}
